var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keywordFormList"},[_c('data-list',{ref:"datalist",attrs:{"table-style":{ name: 'webclient' },"data":_vm.data,"columns":_vm.column}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }